import { render } from "./SplashScreen.vue?vue&type=template&id=39ab9e27&scoped=true&ts=true"
import script from "./SplashScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplashScreen.vue?vue&type=script&setup=true&lang=ts"

import "./SplashScreen.vue?vue&type=style&index=0&id=39ab9e27&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ab9e27"],['__file',"src/lib/components/shared/SplashScreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39ab9e27"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39ab9e27', __exports__)) {
    api.reload('39ab9e27', __exports__)
  }
  
  module.hot.accept("./SplashScreen.vue?vue&type=template&id=39ab9e27&scoped=true&ts=true", () => {
    api.rerender('39ab9e27', render)
  })

}


export default __exports__